import SendRequest from "../lib/ajax";

import { uniqWith, uniqBy, isEqual, groupBy } from 'lodash';

const MovieService = {};

const apiBaseUrl = window.movieApiBaseUrl || 'https://api.shopirvinespectrumcenter.com/umbraco/api/';

const moviesNowPlayingEndpoint = `${apiBaseUrl}fandango/getmovies?theatreId=AABTB&provider=Fandango`;
const moviesComingSoonEndpoint = `${apiBaseUrl}fandango/getcomingsoon?theatreId=AABTB&provider=Fandango`;
const improvShowsEndpoint = `/umbraco/rhythm/improvapi/GetUpcomingShows`;
const movieDetailsEndpoint = `${apiBaseUrl}fandango/getmoviedetails?theatreId=AABTB&provider=Fandango&movieId=`;

const dayMap = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
const monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
const fullMonthMap = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


// the Date constructor in safari doesnt know how to parse the time correctly when passing
// in a string, so we use regex to get the relveant parts from the date string
// and pass those into Date() using the spread operator
function toDate(dateStr) {
    const matches = /(^\d{4})-(\d{1,})-(\d{1,})T(\d{1,}):(\d{1,}):(\d{1,})/g.exec(dateStr);
    matches.shift();
    return new Date(...matches);
}

function formatShowTime(t) {

    const d = toDate(t);

    let hours = d.getHours();
    const minutes = (d.getMinutes()<10?'0':'') + d.getMinutes();

    const meridiem =  hours >= 12 ? "PM" : "AM";
    hours = hours > 12 ? hours - 12 : hours;

    return `${hours}:${minutes}${meridiem}`;
}

function formatImprovShowDateTime(t) {
    return `${formatImprovShowDate(t)} at ${formatShowTime(t)}`;
}

function formatRuntime(t) {
    const hours = Math.floor(t/60);
    const minuteString = t%60 > 0 ? `${t%60} min` : '';

    return `${hours}hr ${minuteString}`;
}

function formatMovieDate(dateString) {
    const d = new Date(dateString);
    const now = new Date();
    const date = d.getDate();
    if(now.getDate() === date) {
        return 'Today';
    }else{
        return `${dayMap[d.getDay()]} - ${monthMap[d.getMonth()]} ${date}`;
    }
}

function formatImprovShowDate(dateString) {
    const d = new Date(dateString);

    return `${dayMap[d.getDay()]}, ${monthMap[d.getMonth()]} ${d.getDate()}`;
}

function groupShowtimesByAmenities(showtimes) {

    // sort by uniq enities
    const showTimesGrouped = uniqWith(showtimes.slice(0), (x, y) => {
        return isEqual(x.amenities, y.amenities)
    });

    // format amenities into display string
    showTimesGrouped.forEach((showtimeByAmenities) => {
        showtimeByAmenities.times = [];
        showtimeByAmenities.header = showtimeByAmenities.amenities
            .map(x => x.name)
            .join(' • ');
    });

    // sort showtimes by amenities
    showtimes.forEach((showtime) => {
        let found = false;
        let i = 0;

        while(!found) {
            if(isEqual(showTimesGrouped[i].amenities, showtime.amenities)) {
                showTimesGrouped[i].times.push(showtime);
                found = true;
            }

            i++;
        }
    }, []);

    return showTimesGrouped;

}

function formatMovieMeta(movie) {
    let foo = [];

    if(movie.runtime) {
        foo.push(formatRuntime(movie.runtime));
    }

    if(movie.rating) {
        foo.push(movie.rating);
    }

    if(movie.genres) {
        if(typeof movie.genres === 'object') {
            foo.push(movie.genres.length ? movie.genres.join(', ') : movie.genres[0]);
        }else{
            foo.push(movie.genres);
        }
    }

    return foo.join(' &nbsp;•&nbsp; ');
}


function formatComingSoon(data) {
    data.forEach(movie => {
        const d = new Date(movie.releaseDate);
        movie.releaseDateDisplay = `Premiering ${dayMap[d.getDay()]}, ${monthMap[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    });

    return data;
}

function formatMonthYear(dateString) {
    const d = new Date(dateString);
    return `${fullMonthMap[d.getMonth()]} ${d.getFullYear()}`;
}

function formatImprovShows(data) {
    const formattedData = [];
    const nameHelper = [];
    const timeHelper = [];
    const monthHelper = [];

    data.forEach((event) => {


        const monthYear = formatMonthYear(event.dates.startDate);
        const monthIndex = monthHelper.indexOf(monthYear);

        const header = formatImprovShowDate(event.dates.startDate);

        const time = {
            link: event.eventUrl,
            time: event.dates.startDate,
            timeDisplay: formatShowTime(event.dates.startDate),
            dateTimeDisplay: formatImprovShowDateTime(event.dates.startDate),
            disabled: isPast(event.dates.startDate),
        };

        if(event.status === 'SoldOut') {
            time.timeDisplay += '<br/>Sold Out';
            time.disabled = true;
        }

        const formattedShow = {
            title: event.eventName,
            image: event.eventImages.large,
            cta: 'Select a showtime to buy tickets',
            showTimesGrouped: [{
                header: header,
                times: [time]
            }]
        };

        if(monthIndex > -1) {

            const nameIndex = nameHelper[monthIndex].indexOf(event.eventName);

            if(nameIndex > -1) {
                const timeIndex = timeHelper[monthIndex][nameIndex].indexOf(header);

                if(timeIndex > -1) {
                    formattedData[monthIndex].shows[nameIndex].showTimesGrouped[timeIndex].times.push(time);
                }else{
                    formattedData[monthIndex].shows[nameIndex].showTimesGrouped.push({
                        header: header,
                        times: [time]
                    });
                    timeHelper[monthIndex][nameIndex].push(header);

                }

            }else{
                nameHelper[monthIndex].push(event.eventName);
                timeHelper[monthIndex].push([header]);
                formattedData[monthIndex].shows.push(formattedShow);
            }

        }else{
            formattedData.push({
                id: monthHelper.length,
                timeDisplay: monthYear,
                shows: [formattedShow]
            });
            monthHelper.push(monthYear);
            nameHelper.push([event.eventName]);
            timeHelper.push([[header]]);
        }

    });

    return formattedData;
}

function isPast(time) {
    return toDate(time).valueOf < Date.now()
}

function formatMovie(movie) {
    if(movie.showTimes) {
        movie.showTimes.forEach(showTime => {
            showTime.timeDisplay = formatShowTime(showTime.time);
            showTime.disabled = isPast(showTime.time);
        });

        movie.cta = 'Select a movie time to buy tickets';
    }
    // movie.runtimeDisplay = formatRuntime(movie.runtime);
    movie.details = formatMovieMeta(movie);
    if(movie.images) {
        movie.image = movie.images[0].url;
        movie.fullImage = movie.images[2].url;
    }else if(movie.image){
        movie.image = movie.image.url;
        movie.fullImage = movie.image;
    }

    movie.detailPageUrl = `/entertainment/movies/details?id=${movie.id}&comingSoon=false`;
}

function formatNowPlaying(data) {
    // while loop so we can remove elements while iterating
    let i = data.length;

    while (i) {
        i--;

        const item = data[i];
        item.id = i;
        item.dateDisplay = formatMovieDate(item.date);

        if(item.movies.length) {


            item.movies
                .forEach((movie) => {
                    formatMovie(movie);
                    movie.showTimesGrouped = groupShowtimesByAmenities(movie.showTimes);
                });

            item.movies.sort((a, b) => {
                const x = a.title.toLowerCase();
                const y = b.title.toLowerCase();
                if(x < y) { return -1 };
                if(x > y) { return 1 };
                return 0;
            });


        }else{
            data.pop();
        }
    }

    return data;
}

function formatMovieDetails(data) {
    formatMovie(data);
    const showTimesByDate = [];

    const helper = [];
    data.showTimes = uniqBy(data.showTimes, x => x.time);

    data.showTimes.forEach((showtime) => {
        const dateDisplay = formatMovieDate(showtime.time);
        const index = helper.indexOf(dateDisplay);
        if(index > -1) {
            showTimesByDate[index].showTimes.push(showtime);
        }else{
            showTimesByDate.push({
                dateDisplay: dateDisplay,
                showTimes: [Object.assign({}, showtime)]
            });
            helper.push(dateDisplay);
        }
    });


    showTimesByDate.forEach((date, index) => {
        date.id = index;
        date.showTimesGrouped = groupShowtimesByAmenities(date.showTimes)
    })

    if(showTimesByDate[0] && showTimesByDate[0].dateDisplay !== 'Today') {
        showTimesByDate.shift();
    }

    data.showTimesByDate = showTimesByDate;

    return data;
}

MovieService.fetch = function(url) {
    return new SendRequest(url)
        .then((res) => {
            if(res.status === 200) {
                return JSON.parse(res.text);
            }else{
                console.error('Attempted to fetch data from: ' + url + ', responded with status code: ' + res.status);
            }

        })
        .catch((err) => {
            console.error('Failed to fetch data from: ' + url);
            console.error(err);
        });
}

MovieService.fetchImprovShows = function() {

    return MovieService.fetch(improvShowsEndpoint)
        .then(data => formatImprovShows(data))
        .catch(err => {
            console.error('error formatting Improv playing data');
            console.error(err);
        })
}

MovieService.fetchNowPlaying = function() {

    return MovieService.fetch(moviesNowPlayingEndpoint)
        .then(data => formatNowPlaying(data))
        .catch(err => {
            console.error('error formatting now playing data');
            console.error(err);
        })
}

MovieService.fetchComingSoon = function() {

    return MovieService.fetch(moviesComingSoonEndpoint)
        .then(data => formatComingSoon(data))
        .catch(err => {
            console.error('error formatting coming soon data');
            console.error(err);
        });
}

MovieService.fetchMovieDetails = function(id, comingSoon = 'false') {

    return MovieService.fetch(movieDetailsEndpoint + id + '&comingSoon=' + comingSoon)
        .then(data => {
            data.comingSoon = (comingSoon !== 'false');
            return formatMovieDetails(data);
        })
        .catch(err => {
            console.error('error formatting movie detail data');
            console.error(err);
        });
}

export default MovieService;
